module.exports = __webpack_public_path__ + "static/media/card-diners-club.a29e5aba.svg";